import { SelectOption } from '@/components/elements/select'
import { Entities } from '@/entities/api/entities'

export const filtersMapCategories = [
	{ name: 'Todos', value: Entities.ALL },
	{ name: 'Accesorios', value: Entities.ACCESSORIES },
	{ name: 'Ropa', value: Entities.CLOTHES },
	{ name: 'Planes personalizados', value: Entities.PLANS_PERSONALIZED },
	{ name: 'Suplementos', value: Entities.SUPPLEMENTS },
]

export const categoryOptions: SelectOption[] = [
	{ label: 'Suplementos', value: Entities.SUPPLEMENTS },
	{ label: 'Planes personalizados', value: Entities.PLANS_PERSONALIZED },
	{ label: 'Ropa', value: Entities.CLOTHES },
	{ label: 'Accesorios', value: Entities.ACCESSORIES },
]
